/* eslint-disable no-underscore-dangle */
import { createSlice } from "@reduxjs/toolkit";
import Constants from "utils/Constants";
import {
  getAllInquiriesThunk,
  getInquiryStatsThunk,
  updateInquiryStatusThunk,
  updateInquiryThunk,
} from "redux/Thunks/Inquiry";
import { resetStateThunk } from "redux/Thunks/Authentication";

const initialState = {
  loading: "idle",
  inquiries: [],
  totalCount: 0,
  stats: {
    total: 0,
    pending: 0,
    processed: 0,
    rejected: 0,
    pendingAmount: 0,
    processedAmount: 0,
  },
};

export const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    updateInquiryInList(state, action) {
      const updatedItem = action.payload;
      const index = state.inquiries.findIndex((item) => item._id === updatedItem._id);
      if (index !== -1) {
        state.inquiries[index] = { ...state.inquiries[index], ...updatedItem };
      }
    },
    removeInquiryFromList(state, action) {
      state.inquiries = state.inquiries.filter((item) => item._id !== action.payload);
      state.totalCount = Math.max(0, state.totalCount - 1);
    },
  },
  extraReducers: {
    [getAllInquiriesThunk.pending]: (state) => {
      if (state.inquiries.length === 0) state.loading = Constants.PENDING;
    },
    [getAllInquiriesThunk.fulfilled]: (state, { payload }) => {
      state.loading = Constants.FULFILLED;
      const list = payload?.data?.data || payload?.data || [];
      state.totalCount = payload?.data?.totalCount ?? (Array.isArray(list) ? list.length : 0);

      if (!payload?.byPassSlice && payload?.type === "add") {
        state.inquiries = Array.isArray(list) ? list : [];
      } else if (!payload?.byPassSlice && payload?.type === "append") {
        if (Array.isArray(list)) {
          state.inquiries.push(...list);
        }
      } else if (Array.isArray(list)) {
        state.inquiries = list;
      }
    },
    [getAllInquiriesThunk.rejected]: (state) => {
      state.loading = Constants.REJECTED;
    },
    [getInquiryStatsThunk.fulfilled]: (state, action) => {
      if (action.payload?.data) {
        state.stats = action.payload.data;
      }
    },
    [updateInquiryStatusThunk.fulfilled]: (state, action) => {
      const updated = action.payload?.data?.data || action.payload?.data;
      if (updated && updated._id) {
        const index = state.inquiries.findIndex((item) => item._id === updated._id);
        if (index !== -1) {
          state.inquiries[index] = { ...state.inquiries[index], ...updated };
        }
      }
    },
    [updateInquiryThunk.fulfilled]: (state, action) => {
      const updated = action.payload?.data?.data || action.payload?.data;
      if (updated && updated._id) {
        const index = state.inquiries.findIndex((item) => item._id === updated._id);
        if (index !== -1) {
          state.inquiries[index] = { ...state.inquiries[index], ...updated };
        }
      }
    },
    [resetStateThunk.fulfilled]: (state) => {
      state.loading = Constants.IDLE;
      state.inquiries = [];
      state.totalCount = 0;
      state.stats = {
        total: 0,
        pending: 0,
        processed: 0,
        rejected: 0,
        pendingAmount: 0,
        processedAmount: 0,
      };
    },
  },
});

export const { updateInquiryInList, removeInquiryFromList } = inquirySlice.actions;

export default inquirySlice.reducer;
